import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {TaskSearchItemsState} from './reducer/task-search-items.reducer';

export const selectTaskSearchItemsFeature = createFeatureSelector<TaskSearchItemsState>(StoreKeys.TASK_SEARCH_ITEMS);

export const selectTaskSearchItemsDatas = createSelector(selectTaskSearchItemsFeature, state => state.datas);
